
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQSection from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';
function Tempotravelleronrentinpune() {



    const cardData =
    {
        keyword: ' Tempo Traveller on Rent Pune',
        heading: 'Samarth Travels: Tempo Traveller on Rent Pune',
        headingDescription: 'Samarth Travels offers dependable and affordable Tempo Traveller rentals in Pune, ideal for group outings, corporate events, or family trips. Choose from a range of well-maintained vehicles, including 12-seater and 13-seater options, all equipped with comfortable seating and essential amenities. With transparent pricing, no hidden charges, and a commitment to punctuality and customer satisfaction, Samarth Travels ensures a smooth and enjoyable travel experience across Pune and beyond.',

        top: 'Top Places to Visit in Pune with Samarth Travels',

        "topPlaces": [
            {
                "title": "Shaniwar Wada",
                "description": "Shaniwar Wada is one of Pune's most iconic landmarks and a symbol of the Maratha Empire. Built in 1732 as the seat of the Peshwas, this grand fortification features majestic gates, elegant fountains, and intricate architecture. Although much of it was destroyed by fire in 1828, its massive stone walls and legendary tales—especially those surrounding the ghost of Narayanrao—still attract thousands of history lovers and tourists each year."
            },
            {
                "title": "Aga Khan Palace",
                "description": "The Aga Khan Palace is a stunning historical monument built in 1892 by Sultan Aga Khan III. It holds immense national significance due to its association with Mahatma Gandhi, Kasturba Gandhi, and other freedom fighters who were imprisoned here during the Quit India Movement. Set in lush green gardens, the palace showcases Italian arches and spacious halls and also houses a museum with photographs, paintings, and personal belongings of Gandhi, making it a must-visit for those interested in India’s independence movement."
            },
            {
                "title": "Sinhagad Fort",
                "description": "Perched atop the Sahyadri hills, Sinhagad Fort is a historic hill fortress located about 30 kilometers from Pune. Famous for the Battle of Sinhagad in 1670, where Maratha warrior Tanaji Malusare fought valiantly, the fort offers breathtaking views, trekking trails, and remnants of ancient military architecture including bastions, gates, and memorials. It's an ideal destination for trekking enthusiasts, history buffs, and nature lovers alike."
            },
            {
                "title": "Pataleshwar Cave Temple",
                "description": "The Pataleshwar Cave Temple is a unique 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from a single massive basalt rock, this ancient temple is a fine example of monolithic architecture from the Rashtrakuta period. Its main sanctum houses a linga, and the surrounding sanctum sanctorum includes statues of other deities. Despite being in the middle of the bustling city, it offers a tranquil and spiritual atmosphere for visitors."
            },
            {
                "title": "Dagdusheth Halwai Ganpati Temple",
                "description": "This revered Ganesh temple is one of the most visited and richly adorned temples in Maharashtra. Established by a sweet-maker named Dagdusheth Halwai in the late 19th century, the temple is known for its magnificent idol of Lord Ganesh decked in gold and diamonds. The temple draws massive crowds during the Ganesh Chaturthi festival, and its serene ambiance makes it a spiritual haven throughout the year."
            },
            {
                "title": "Raja Dinkar Kelkar Museum",
                "description": "This museum is a treasure trove of Indian heritage and folk art, established by Dr. Dinkar Kelkar in memory of his son. It houses over 20,000 rare and artistic artifacts, including musical instruments, sculptures, paintings, utensils, weaponry, and textiles from all over India. The collection gives a vivid picture of everyday life in bygone eras and is especially appealing to art enthusiasts and cultural historians."
            },
            {
                "title": "Parvati Hill and Temple",
                "description": "Rising 2,100 feet above sea level, Parvati Hill offers panoramic views of Pune city. The hilltop temple complex consists of five main temples, including the Devdeveshwar temple dedicated to Lord Shiva and Goddess Parvati. Built during the Peshwa rule, it is not only a religious site but also a peaceful escape from the city buzz. A climb of 103 stone steps leads to the summit, where history and nature meet."
            },
            {
                "title": "Osho Ashram",
                "description": "Located in the serene Koregaon Park area, the Osho International Meditation Resort is a tranquil oasis for seekers of inner peace and mindfulness. Founded by the spiritual guru Osho, it offers daily meditation sessions, yoga programs, and various wellness therapies in a luxurious, Zen-like environment. Visitors from all over the world come here for spiritual growth, rejuvenation, and to experience the calm ambiance of its lush gardens and modern facilities."
            },
            {
                "title": "Pune Okayama Friendship Garden",
                "description": "Also known as Pu La Deshpande Garden, this beautifully landscaped garden is inspired by Japan’s Okayama Korakuen Garden. Spread over 10 acres, it features artistically arranged lawns, water bodies, bridges, and pathways that create a harmonious blend of nature and design. It's a favorite among photography enthusiasts, families, and couples seeking a peaceful retreat amid nature."
            },
            {
                "title": "Katraj Snake Park and Rajiv Gandhi Zoological Park",
                "description": "This combined facility includes a zoo, snake park, and a wildlife rescue center. The snake park is known for its wide variety of snakes, including the King Cobra and Indian Python, as well as informative exhibits on reptile behavior and conservation. The adjoining zoo is home to tigers, leopards, elephants, and other animals, making it an engaging educational and recreational spot, especially for children and families."
            }
        ],

      "services": [
    {
        "name": "Rent a Tempo Traveller for Pune Sightseeing",
        "description": "Discover Pune’s historical landmarks, cultural attractions, and natural beauty by renting a Tempo Traveller with Samarth Travels. Perfect for families and groups, our spacious and air-conditioned vehicles come with experienced drivers who know the city inside out. Enjoy a relaxing, well-planned sightseeing tour at your own pace."
    },
    {
        "name": "Pune Tempo Traveller Rental for Group Travel",
        "description": "Planning a group trip in or around Pune? Samarth Travels offers Tempo Travellers equipped for comfort and safety. Whether you're touring Maharashtra, attending a function, or heading to a pilgrimage, our group travel rentals ensure seamless transportation with ample space for passengers and luggage."
    },
    {
        "name": "Budget-Friendly Tempo Traveller Rent in Pune",
        "description": "Looking for cost-effective travel options without compromising on quality? Samarth Travels offers budget-friendly Tempo Traveller rentals in Pune that suit every pocket. Ideal for students, large families, or casual group outings, our service combines affordability with cleanliness, punctuality, and courteous drivers."
    },
    {
        "name": "Tempo Traveller on Rent for Corporate Trips in Pune",
        "description": "Make your corporate travel hassle-free with Samarth Travels’ Tempo Traveller rental service in Pune. Whether it's team outings, airport transfers, conferences, or business tours, we provide clean, air-conditioned vehicles driven by professionals who understand time sensitivity and corporate etiquette."
    },
    {
        "name": "AC Tempo Traveller on Rent in Pune",
        "description": "Beat the heat and travel in comfort with our fully air-conditioned Tempo Travellers for rent in Pune. Samarth Travels offers reliable AC vehicles for city tours, outstation trips, or daily commute needs — all maintained to the highest standards and driven by experienced chauffeurs."
    },
    {
        "name": "Rent a Tempo Traveller for Weddings in Pune",
        "description": "Ensure your guests arrive in style and comfort by renting a Tempo Traveller for weddings with Samarth Travels. From shuttling guests between venues to transporting family members, our wedding transport solutions in Pune are elegant, timely, and perfect for large groups."
    },
    {
        "name": "Luxury Tempo Traveller on Rent in Pune",
        "description": "Travel in style with Samarth Travels’ luxury Tempo Travellers in Pune. Ideal for VIP events, executive travel, or special occasions, our luxury vehicles feature plush seating, air conditioning, music systems, and ample space — delivering a first-class group travel experience."
    },
    {
        "name": "Tempo Traveller for Rent in Pune for Family Trips",
        "description": "Planning a family vacation or temple tour? Samarth Travels offers spacious and comfortable Tempo Travellers on rent in Pune, ideal for families who want to travel together. With professional drivers and well-maintained vehicles, enjoy a smooth and enjoyable ride for all age groups."
    },
    {
        "name": "Tempo Traveller for Rent Pune for Business Events",
        "description": "Organizing a seminar, team building retreat, or trade event in Pune? Rent a Tempo Traveller from Samarth Travels for smooth and timely transportation of your staff or clients. We provide dedicated corporate travel support and reliable service tailored for business needs."
    },
    {
        "name": "14-Seater Tempo Traveller Rental Pune",
        "description": "Need the right-sized vehicle for your group? Our 14-seater Tempo Traveller rental in Pune is the perfect fit for medium-sized groups looking for comfort, convenience, and affordability. Samarth Travels ensures a stress-free travel experience with professional service and well-maintained vehicles."
    }
],
"tableData": [
    ["Rent a Tempo Traveller for Pune Sightseeing", "Pune Tempo Traveller Rental for Group Travel"],
    ["Budget-Friendly Tempo Traveller Rent in Pune", "Tempo Traveller on Rent for Corporate Trips in Pune"],
    ["AC Tempo Traveller on Rent in Pune", "Rent a Tempo Traveller for Weddings in Pune"],
    ["Luxury Tempo Traveller on Rent in Pune", "Tempo Traveller for Rent in Pune for Family Trips"],
    ["Tempo Traveller for Rent Pune for Business Events", "14-Seater Tempo Traveller Rental Pune"]
],


       "whychoose": [
    {
        "WhyChooseheading": "Top-Rated Tempo Traveller on Rent in Pune",
        "WhyChoosedescription": "Samarth Travels is a trusted name for Tempo Traveller on rent in Pune, offering reliable and quality group travel services for all occasions—be it family vacations, corporate events, school trips, or pilgrimages. Our timely service, clean vehicles, and commitment to customer satisfaction make us the preferred choice for comfortable travel."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Vehicles for Every Group Size",
        "WhyChoosedescription": "Our fleet of Tempo Travellers includes 9-seater, 12-seater, 17-seater, and 26-seater options, all equipped with push-back seats, ample legroom, strong air-conditioning, and entertainment systems. Whether you're planning a day trip or a long-distance journey, we ensure every passenger travels in comfort and style."
    },
    {
        "WhyChooseheading": "Experienced Drivers Who Know Pune and Beyond",
        "WhyChoosedescription": "Our drivers are not only licensed and experienced but also courteous and punctual. With in-depth knowledge of Pune and popular routes across Maharashtra and India, they ensure timely arrivals, safe driving, and a smooth travel experience. Your safety and comfort are their top priorities."
    },
    {
        "WhyChooseheading": "Transparent, Affordable Pricing with No Hidden Costs",
        "WhyChoosedescription": "At Samarth Travels, we believe in honesty and clarity. Our Tempo Traveller rental plans in Pune are budget-friendly, with all charges explained upfront. No hidden fees or last-minute surprises—just straightforward pricing that fits your budget and ensures value for money."
    },
    {
        "WhyChooseheading": "24/7 Availability for All Your Travel Needs",
        "WhyChoosedescription": "Whether you need a Tempo Traveller early in the morning or late at night, we are ready to serve you round-the-clock. Our 24/7 availability makes us a reliable choice for outstation tours, airport transfers, weddings, and urgent bookings—even at odd hours."
    },
    {
        "WhyChooseheading": "Instant Booking with Live Updates and Support",
        "WhyChoosedescription": "Book your Tempo Traveller easily through our website or customer care. Once booked, get real-time updates including driver contact, vehicle tracking, and estimated arrival times. Our support team is always available to assist with changes, queries, or emergencies during your trip."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Regularly Serviced Fleet",
        "WhyChoosedescription": "We maintain our Tempo Travellers to the highest hygiene and safety standards. Each vehicle is deep-cleaned and sanitized after every trip, and undergoes routine maintenance checks to ensure mechanical reliability, cleanliness, and your peace of mind during travel."
    },
    {
        "WhyChooseheading": "Flexible Payment Options for a Hassle-Free Experience",
        "WhyChoosedescription": "To make your travel seamless, we offer multiple payment modes including cash, UPI, credit/debit cards, and digital wallets. Whether you're an individual or a business, our payment flexibility ensures a smooth booking and billing process every time you rent with us."
    }
]













    }

   const faqData = [
    {
        id: 1,
        question: 'How do I rent a Tempo Traveller in Pune with Samarth Travels?',
        answer: 'Renting a Tempo Traveller in Pune is easy with Samarth Travels. You can book directly through our website or contact our customer support. Just share your travel dates, group size, and destination—we’ll recommend the best vehicle and finalize your booking quickly.',
    },
    {
        id: 2,
        question: 'What seating options are available for Tempo Traveller on rent in Pune?',
        answer: 'Samarth Travels offers a wide range of seating options, including 9-seater, 12-seater, 17-seater, and 20-seater Tempo Travellers. Whether it’s a family trip, corporate outing, or school picnic, we have the right vehicle for your needs.',
    },
    {
        id: 3,
        question: 'What is included in the rental fare for a Tempo Traveller in Pune?',
        answer: 'Our rental fare includes driver charges, fuel, and applicable taxes. We provide transparent pricing with no hidden fees. If tolls or parking charges apply during the journey, those will be mentioned clearly before the trip.',
    },
    {
        id: 4,
        question: 'Can I rent a Tempo Traveller in Pune for outstation trips?',
        answer: 'Yes, you can rent a Tempo Traveller from Samarth Travels for outstation journeys from Pune. Whether you’re heading to Mahabaleshwar, Lonavala, Shirdi, or any other destination, our vehicles are ideal for long-distance travel.',
    },
    {
        id: 5,
        question: 'Is there a minimum rental duration for Tempo Travellers in Pune?',
        answer: 'We offer flexible rental durations, from a few hours to multi-day trips. Whether it’s a quick city tour or a long weekend getaway, we’ll tailor the rental package to suit your travel plan.',
    },
    {
        id: 6,
        question: 'Are Tempo Travellers from Samarth Travels comfortable for long trips?',
        answer: 'Absolutely. Our Tempo Travellers are air-conditioned and equipped with pushback seats, ample legroom, and luggage space. Comfort and safety are our top priorities for long-distance journeys.',
    },
    {
        id: 7,
        question: 'Can I book a Tempo Traveller in Pune for early morning or late night travel?',
        answer: 'Yes, we provide 24/7 booking and travel services. You can schedule pickups and drop-offs at any hour—early morning departures or late night returns—without any hassle.',
    },
];

const testimonials = [
    {
        name: 'Mr. Anil Deshmukh',
        role: 'Business Owner',
        text: 'We hired a Tempo Traveller from Samarth Travels for an outstation business trip. The vehicle was in great condition and the driver was very professional. Highly satisfied with their service!',
        image: '/img/testimonial/testi_2_4.jpg',
    },
    {
        name: 'Miss. Pooja Bhosale',
        role: 'College Student',
        text: 'Booked a 12-seater Tempo Traveller for our college trip from Pune to Mahabaleshwar. Clean vehicle, smooth journey, and great support from Samarth Travels. Will recommend to friends!',
        image: '/img/testimonial/testi_2_5.jpg',
    },
];













    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9860256019",
            "+91 9527500025",

        ],
        email: "samarthtravels9119@gmail.com"
    };


   const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " Tempo Traveller Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Tempo Traveller on Rent Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: " Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: " Tempo Traveller on Rent",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Tempo Traveller Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Tempo Traveller Hire in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: " Mini Bus for Rent",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Bus on Rent Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: " Bus on Rent Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: " Bus Rental in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: " Hire Tempo Traveller",
        },
        {
            place: "/images/keyword/12.jpg",
            text: " Bus Hire in Pune",
        },
        {
            place: "/images/keyword/13.jpg",
            text: " Ac Tempo Traveller Rent Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: " Bus Hire For Outstation",
        },
        {
            place: "/images/keyword/15.jpg",
            text: " Bus on Rent for Local",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Bus Rental For Wedding",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Bus Rent for Marriage",
        },
        {
            place: "/images/keyword/18.jpg",
            text: " Bus Rental For Corporate Events",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "  Bus Rental for Tour",
        },

        {
            place: "/images/keyword/20.jpg",
            text: "Bus Rental For Corporate in Pune",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/22.jpg",
            text: " AC Bus On Rent",
        },
        {
            place: "/images/keyword/23.jpg",
            text: " Non Ac Bus Rental Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Bus on Hire on Pune to Mahabaleshwar Package Tour ",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Bus Hire for Picnic",
        },
    ];


    const images = [
        { src: "/images/fleets/1.jpg", alt: "Image 1" },
        { src: "/images/fleets/2.jpg", alt: "Image 1" },
        { src: "/images/fleets/3.jpg", alt: "Image 1" },
        { src: "/images/fleets/4.jpg", alt: "Image 1" },
        { src: "/images/fleets/5.jpg", alt: "Image 1" },
        { src: "/images/fleets/6.jpg", alt: "Image 1" },
        { src: "/images/fleets/7.jpg", alt: "Image 1" },
        { src: "/images/fleets/8.jpg", alt: "Image 1" },
        { src: "/images/fleets/9.jpg", alt: "Image 1" },


    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller on Rent Pune",
  "image": "https://samarthtravels.com/assets/images/tempo-traveller-on-rent-pune.jpg",
  "description": "Book Tempo Traveller on Rent in Pune with Samarth Travels. Affordable and luxury AC Tempo Travellers available for family trips, corporate events, weddings, and group sightseeing. Options include 14-seater, 17-seater, and more.",
  "brand": {
    "@type": "Brand",
    "name": "Samarth Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3200",
    "availability": "https://schema.org/InStock",
    "url": "https://samarthtravels.com/tempo-traveller-on-rent-pune"
  }
};



    return (
        <div>

<Helmet>
  <title>Tempo Traveller on Rent in Pune | AC, Luxury & 14-Seater | Samarth Travels</title>
  <meta 
    name="description" 
    content="Hire AC Tempo Traveller on Rent in Pune for sightseeing, family trips, corporate events & weddings. Budget-friendly and luxury options available with Samarth Travels, including 14-seater and more." 
  />
  <meta 
    name="keywords" 
    content="Rent a Tempo Traveller for Pune Sightseeing, Pune Tempo Traveller Rental for Group Travel, Budget-Friendly Tempo Traveller Rent in Pune, Tempo Traveller on Rent for Corporate Trips in Pune, AC Tempo Traveller on Rent in Pune, Rent a Tempo Traveller for Weddings in Pune, Luxury Tempo Traveller on Rent in Pune, Tempo Traveller for Rent in Pune for Family Trips, Tempo Traveller for Rent Pune for Business Events, 14-Seater Tempo Traveller Rental Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div className="breadcumb-wrapper" data-bg-src="/images/breadcumb-bg.jpg">
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title text-center">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/2.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Samarth Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQSection faqs={faqData} accordionId="drivingAccordion" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword
                                data={testimonials}
                                title="What Our Clients Are Saying"
                                subtitle="Customer Feedback"
                            />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF8F1F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF8F1F' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919860256019" className="d-block  text-white">+91 9860256019</a>
                                                <a href="tel:+919527500025" className="d-block  text-white">+91 9527500025</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:samarthtravels9119@gmail.com" className=" text-white d-block">
                                                    samarthtravels9119@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Samarth Travels <br />
                                                        Flat no 201, Juhi Building, Suyash Shrushti Society, Tukai darshan Hadapsar, Pune- 411028
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Tempotravelleronrentinpune;